import Vue from 'vue'
import Buefy from 'buefy'
import VeeValidate from 'vee-validate'
import VueGtag from 'vue-gtag'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import validationMessagesEn from 'vee-validate/dist/locale/en'
import validationMessagesTr from 'vee-validate/dist/locale/tr'
import App from './App.vue'
import router from './router'
import store from './store'

import ApiService from './_api/api.service'
import DateFilter from './_helpers/date.filter'

import './assets/scss/app.scss'
// import './assets/scss/custom-theme.scss'
import i18n from './i18n'

import GlobalComponents from './plugins/globalComponents'
import GlobalDirectives from './plugins/globalDirectives'

Vue.use(Buefy, { defaultIconPack: 'fas' })

Vue.use(VeeValidate, {
  i18n,
  dictionary: {
    en: validationMessagesEn,
    tr: validationMessagesTr
  },
  events: '',
  fieldsBagName: 'vFields',
  mode: 'lazy'
})

Vue.use(VueReCaptcha, {
  siteKey: '6Lf1OeAZAAAAAB4YO9PLUgLebWJGKo5U72KD4wUt',
  loaderOptions: {
    useRecaptchaNet: true
  }
})

Vue.use(
  VueGtag,
  {
    config: { id: 'G-D8GHT4KSCQ' },
    includes: [{ id: 'AW-782513152' }]
  },
  router
)

Vue.use(GlobalComponents)
Vue.use(GlobalDirectives)

Vue.filter('date', DateFilter.date)
Vue.filter('datetime', DateFilter.datetime)

ApiService.init()

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
